import React, {PureComponent} from "react"
import {get} from "lodash"

import {Body} from "@irati/ui/src/Typography"
import {connect} from "@irati/store"
import {ReduxState} from "@irati/store/types"

import {Container, Bullet, Pipe} from "./styled/Item"

interface Props {
  isPhone: boolean
  text: string
  isFirstItem?: boolean
}

class Item extends PureComponent<Props> {
  static defaultProps = {
    isFirstItem: false
  }

  render() {
    const {isPhone, text, isFirstItem} = this.props

    return (
      <Container>
        {!isFirstItem && (isPhone ? <Bullet>&bull;</Bullet> : <Pipe />)}
        <Body small>{text}</Body>
      </Container>
    )
  }
}

const mapStateToProps = ({mq}: ReduxState) => ({
  isPhone: get(mq, "lessThan.medium", false)
})

export default connect(mapStateToProps)(Item)
